"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.56 8.73a1.51 1.51 0 0 0-1.41-1h-6.09a.5.5 0 0 1-.47-.33l-2.18-6.2A1.52 1.52 0 0 0 12 .25a1.49 1.49 0 0 0-1.4 1L8.41 7.42a.5.5 0 0 1-.47.33H1.85a1.5 1.5 0 0 0-1.41 1 1.52 1.52 0 0 0 .45 1.65l5.18 4.3a.5.5 0 0 1 .16.54l-2.18 6.53a1.5 1.5 0 0 0 2.31 1.69l5.34-3.92a.49.49 0 0 1 .59 0l5.35 3.92A1.5 1.5 0 0 0 20 21.77l-2.18-6.53a.5.5 0 0 1 .16-.54l5.19-4.31a1.51 1.51 0 0 0 .39-1.66Z"
}), 'RatingStarFilled');

exports.default = _default;